import client from "lib/apolloClient/client";
import {
  getChatListQuery,
  getAllChatListQuery,
  getChatUnreadCountQuery,
  getChannelListQuery,
  getTotalChatAndChannelCountQuery,
  getChatAndChannelListQuery,
} from "./ThreadListQueries";

export const getChatListFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getChatListQuery,
      variables,
    });

    return result;
  } catch (e) {
    return {};
  }
};

export const getAllChatListFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getAllChatListQuery,
      variables,
    });

    return result;
  } catch (e) {
    return {};
  }
};

export const getChannelListFromCache = ({ variables }) => {
  try {
    const result = client.readQuery({
      query: getChannelListQuery,
      variables,
    });

    return result;
  } catch (e) {
    return {};
  }
};

export const writeChannelListToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getChannelListQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getChatUnreadCountQueryFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getChatUnreadCountQuery,
      variables,
    });

    return result;
  } catch (e) {
    return {};
  }
};

export const writeChatUnreadCountToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getChatUnreadCountQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getTotalChatAndChannelCountQueryFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getTotalChatAndChannelCountQuery,
      variables,
    });

    return result;
  } catch (e) {
    return {};
  }
};

export const getChatAndChannelListFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getChatAndChannelListQuery,
      variables,
    });
    return result;
  } catch (e) {
    return {};
  }
};

export const writeChatAndChannelListToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getChatAndChannelListQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};
